var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-appbar',{attrs:{"filterabl":"","backTo":_vm.rota}},[_vm._v(" Lotes ")])
}
var staticRenderFns = []

export { render, staticRenderFns }